import MerchantOperatingHoursPage from '../../../components/merchant/settings/operating-hours/MerchantOperatingHoursPage'

export default function SettingsOperatingHours() {
  return <MerchantOperatingHoursPage />
}
